import { useCallback, useEffect } from 'react'
import { array, func, node, object, oneOf, string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Portal } from '../portal'
import {
  LeftWrapper,
  PopupOverlay,
  PopupWrapper,
  RightWrapper,
  TitleBar
} from '../popup-new/styled-components'
import { ModalBody, ModalFooter, ModalWindow } from './styled-components'
import PopupNewActionButton from '../popup-new/components/popup-new-action-button'

/*
 * Pop up customized to fit project settings
 * Update/use style when pop ups are to be changed all around
 */
const Popup = ({
  title,
  values,
  label,
  background,
  leftButtons,
  rightButtons,
  children,
  closePopUp,
  size
}) => {
  const handleEscKeyPress = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        closePopUp()
      }
    },
    [closePopUp]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleEscKeyPress)
    return () => {
      document.removeEventListener('keydown', handleEscKeyPress)
    }
  }, [handleEscKeyPress])

  return (
    <Portal node={document.getElementById('root')}>
      <>
        <PopupOverlay />
        <PopupWrapper>
          <ModalWindow background={background} size={size}>
            {title && (
              <TitleBar values={!!values}>
                {!values && (
                  <span className="title">
                    <span className="edit">{label}</span>
                    {title}
                  </span>
                )}
                {values && (
                  <span className="title">
                    <FormattedMessage {...title} values={values} />
                  </span>
                )}
              </TitleBar>
            )}
            <ModalBody>{children}</ModalBody>
            <ModalFooter>
              <LeftWrapper>
                {leftButtons?.map((leftButton, index) => (
                  <PopupNewActionButton
                    key={`${leftButton.text}${title}${index}`}
                    {...leftButton}
                  />
                ))}
              </LeftWrapper>
              <RightWrapper>
                {rightButtons?.map((rightButton, index) => (
                  <PopupNewActionButton
                    key={`${rightButton.text}${title}${index}`}
                    {...rightButton}
                  />
                ))}
              </RightWrapper>
            </ModalFooter>
          </ModalWindow>
        </PopupWrapper>
      </>
    </Portal>
  )
}

Popup.propTypes = {
  children: node,
  background: string,
  rightButtons: array,
  leftButtons: array,
  closePopUp: func,
  title: object,
  values: object,
  label: string,
  size: oneOf(['SMALL', 'MID', 'LARGE'])
}

export default Popup
